module.exports = __webpack_public_path__ + "static/media/nft_blog_img.5d3f057a.jpg";